/** @format */
import isPropValid from '@emotion/is-prop-valid';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { styles } from './character-counter.styles';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type CharacterCounterProps = {
    count: number;
    max: number;
    'data-testid'?: string;
};

const blacklistedProps = ['max'];

const StyledCharacterCounter = styled('div').withConfig({
    shouldForwardProp: (prop) =>
        isPropValid(prop) && !blacklistedProps.includes(prop),
})`
    ${styles}
`;

/**
 * @deprecated use @feather/components/atoms/character-counter instead
 */
export const CharacterCounter: FunctionComponent<CharacterCounterProps> = ({
    count,
    max,
}: CharacterCounterProps) => {
    const { t } = useTranslation();

    const characters = Math.abs(max - count);

    return (
        <StyledCharacterCounter
            count={count}
            max={max}
            data-testid="character-counter"
        >
            {count > max
                ? t('You have {{characters}} characters too many', {
                      characters,
                  })
                : t('You have {{characters}} characters remaining', {
                      characters,
                  })}
        </StyledCharacterCounter>
    );
};
